// eslint-disable-next-line max-classes-per-file
import {
  LOGIN_REDIRECT_URL,
  LOUGOUT_URL,
  LOGIN_AUTHORITY_SCOPE,
  SILENT_URL
} from "utils/constants";
import { redirect } from "@company-mrv/mrv-design-system/components";
import MOCK from "utils/mock";
import {
  User as OidcUser,
  UserManager as UserManagerLib,
  WebStorageStateStore
} from "oidc-client-ts";

const LOCAL_STORAGE_KEY = "IDSAuthMock";

class UserManager extends UserManagerLib {
  clearStaleState = async () =>
    new Promise(acept => {
      localStorage.removeItem(LOCAL_STORAGE_KEY);
      acept(true);
    });

  getUser = async () =>
    new Promise(acept => {
      const user = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (user) {
        return acept(JSON.parse(user));
      }
      return acept(undefined);
    });

  removeUser = () => {
    const returnDefault = true;
    return returnDefault;
  };

  signinRedirect = async () => {
    redirect("/relacionamento/entrar-mock");
  };

  signinRedirectCallback = async () =>
    new Promise((acept, rej) => {
      const user = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (user) {
        acept(true);
      }
      rej();
    });

  signinSilent = async () =>
    new Promise((acept, rej) => {
      const user = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (user) {
        acept(true);
      }
      rej();
    });

  signinSilentCallback = async () =>
    new Promise(acept => {
      const user = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (user) {
        acept(JSON.parse(user));
      }
      acept(undefined);
    });

  signoutRedirect = async () => {
    await this.clearStaleState();
    redirect(this.settings.redirect_uri);
  };

  signoutRedirectCallback = async () => {
    const returnDefault = true;
    return returnDefault;
  };

  addUserLoadedList = [];
}

class AuthService {
  constructor() {
    const settings = {
      // authority: LOGIN_AUTHORITY_URL,
      // client_id: LOGIN_CLIENT_ID,
      redirect_uri: LOGIN_REDIRECT_URL,
      post_logout_redirect_uri: LOUGOUT_URL,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      // response_type: 'code',
      scope: LOGIN_AUTHORITY_SCOPE,
      automaticSilentRenew: false,
      silent_redirect_uri: SILENT_URL,
      // response_mode: 'query',
      revokeTokensOnSignout: true,
      revokeTokenTypes: ["access_token"]
    };
    this.userManager = new UserManager(settings);
    this.eventTokenExpired = false;
  }

  tokenExpired = async () => {
    if (!this.eventTokenExpired) {
      this.eventTokenExpired = true;
    }
  };

  // only exists here (mock)
  setUser(cpf) {
    const user = MOCK[cpf] !== undefined ? MOCK[cpf] : MOCK["000.000.000-01"];
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(user.auth));
    localStorage.setItem(
      "oidc.user:MOCK",
      JSON.stringify({ ...user.auth, id_token: user.auth.access_token })
    );
    this.userManager.addUserLoadedList.forEach(f => f(user.auth));
    return user.auth;
  }

  getIdToken = async () => {
    const user = await this.getUser();
    return (user || {}).id_token;
  };

  login = async () => {
    return this.userManager.signinRedirect();
  };

  renew = async () => {
    return this.userManager.signinSilent();
  };

  renewCallback = async () => {
    return this.userManager.signinSilentCallback();
  };

  logout = async () => {
    const idToken = await this.getIdToken();
    await this.userManager.signoutRedirect({
      id_token_hint: idToken
    });
  };

  signoutRedirectCallback = async () => {
    return new Promise((acept, rej) => {
      this.userManager
        .signoutRedirectCallback()
        .then(() => {
          this.userManager.removeUser();
          this.userManager.clearStaleState();
          acept();
        })
        .catch(err => {
          rej(err);
        });
    });
  };

  getUser = async () => {
    return this.getSoftAuthUser() || this.userManager.getUser();
  };

  getEvents = () => {
    return this.userManager.events;
  };

  loginCallback = async () => {
    return this.userManager.signinRedirectCallback();
  };

  clear = async () => {
    return this.userManager.clearStaleState();
  };

  // token management

  SOFT_AUTHORIZATION_KEY = "SOFT_AUTHORIZATION";

  removeSoftAuthorizationToken = () => {
    localStorage.removeItem(this.SOFT_AUTHORIZATION_KEY);
  };

  removeOidcAuthorization = () => {
    // Coleta antes de remover: remover durante a iteração por índice desloca
    // as chaves e pula a seguinte, deixando `oidc.*` órfão no storage.
    const chavesOidc = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const chave = localStorage.key(i);
      if (chave && chave.substring(0, 5) === "oidc.") {
        chavesOidc.push(chave);
      }
    }
    chavesOidc.forEach(chave => localStorage.removeItem(chave));
  };

  // Descarta usuário e estados do oidc-client e inicia um login novo. Usado
  // quando a sessão do IdS venceu (login_required e afins) ou quando o estado
  // local ficou órfão/inválido — casos que pedem login, não tela de erro.
  reiniciarLogin = async () => {
    try {
      await this.userManager.removeUser();
    } catch (e) {
      console.error("Erro ao remover usuário do oidc-client", e);
    }
    try {
      await this.userManager.clearStaleState();
    } catch (e) {
      console.error("Erro ao limpar estado do oidc-client", e);
    }
    this.removeOidcAuthorization();
    return this.login();
  };

  clearUserStorage = async () => {
    this.removeSoftAuthorizationToken();
    this.removeOidcAuthorization();
    sessionStorage.clear();
    return this.userManager.clearStaleState();
  };

  completeLoginVistoriador = async (data, cpf, email) => {
    await this.clearUserStorage();
    await this.setOidcUser(data.token);
    this.setSoftAuthorizationToken(
      JSON.stringify({
        va: true,
        ...JSON.parse(data.softAuthToken),
        access_token: JSON.parse(data.token).access_token,
        cpf,
        email
      })
    );
  };

  completeLoginVistoriadorCohab = async (
    data,
    cpf,
    email,
    nome,
    numeroOcorrencia
  ) => {
    await this.clearUserStorage();
    await this.setOidcUser(data.token);
    this.setSoftAuthorizationToken(
      JSON.stringify({
        va: true,
        cohab: true,
        ...JSON.parse(data.softAuthToken),
        access_token: JSON.parse(data.token).access_token,
        cpf,
        email,
        nome,
        numeroOcorrencia
      })
    );
  };

  completeLoginEC = async (data, cpf, email) => {
    await this.clearUserStorage();
    await this.setOidcUser(data.token);
    this.setSoftAuthorizationToken(
      JSON.stringify({
        ec: true,
        ...JSON.parse(data.softAuthToken),
        access_token: JSON.parse(data.token).access_token,
        cpf,
        email
      })
    );
  };

  setOidcUser = async userString => {
    const user = JSON.parse(userString);
    const userObj = new OidcUser(user);
    await this.userManager.storeUser(userObj);
  };

  setSoftAuthorizationToken = token => {
    localStorage.setItem(this.SOFT_AUTHORIZATION_KEY, token);
  };

  getSoftAuthorizationToken = () => {
    try {
      return JSON.parse(localStorage.getItem(this.SOFT_AUTHORIZATION_KEY));
    } catch (e) {
      return null;
    }
  };

  getSoftAuthUser = () => {
    const softAuthToken = this.getSoftAuthorizationToken();

    if (!softAuthToken) return null;

    return {
      isSoftauth: true,
      ...softAuthToken
    };
  };

  renewSoftAuth = async () => {
    const user = this.getSoftAuthUser();
    if (!user) return null;

    // Create a fake JWT with a future expiration
    const header = btoa(JSON.stringify({ alg: "HS256", typ: "JWT" }));
    const now = Math.floor(Date.now() / 1000);
    const payload = btoa(
      JSON.stringify({
        sub: user.sub || "mock-user",
        name: user.name || "Mock User",
        exp: now + 3600, // Expires in 1 hour
        iat: now
      })
    );
    const signature = "mock-signature";
    const newToken = `${header}.${payload}.${signature}`;

    const updatedUser = {
      ...user,
      access_token: newToken
    };

    this.setSoftAuthorizationToken(JSON.stringify(updatedUser));
    return updatedUser;
  };

  clearLocalStorageSoft = async () => {
    await this.clearUserStorage();
  };
}

export default new AuthService();
